// PageSkeleton Component
import { Box, Container, Skeleton } from '@mui/material';

interface PageSkeletonProps {
  showHeader?: boolean;
  showSidebar?: boolean;
  cardCount?: number;
}

const InlineCardSkeleton = () => (
  <Box
    sx={{
      p: 2,
      borderRadius: 2,
      bgcolor: 'background.paper',
      border: 1,
      borderColor: 'divider',
    }}
  >
    <Box display="flex" gap={1} mb={2}>
      <Skeleton variant="rounded" width={80} height={24} />
      <Skeleton variant="rounded" width={60} height={24} />
    </Box>
    <Skeleton variant="text" height={28} sx={{ mb: 1 }} />
    <Skeleton variant="text" height={20} width="80%" sx={{ mb: 2 }} />
    <Box display="flex" flexDirection="column" gap={1}>
      <Skeleton variant="rounded" height={48} />
      <Skeleton variant="rounded" height={48} />
    </Box>
    <Box display="flex" justifyContent="space-between" mt={2}>
      <Skeleton variant="text" width={100} />
      <Skeleton variant="text" width={80} />
    </Box>
  </Box>
);

// Pre-computed array
const createCardArray = (count: number) => Array.from({ length: count }, (_, i) => i);

export const PageSkeleton = ({
  showHeader = true,
  showSidebar = false,
  cardCount = 6,
}: PageSkeletonProps) => {
  const cardArray = createCardArray(cardCount);

  return (
    <Container maxWidth="lg">
      {showHeader && (
        <Box mb={4}>
          <Skeleton variant="text" width={300} height={48} sx={{ mb: 1 }} />
          <Skeleton variant="text" width={200} height={24} />
        </Box>
      )}

      <Box
        display="grid"
        gridTemplateColumns={showSidebar ? { xs: '1fr', md: '1fr 300px' } : '1fr'}
        gap={3}
      >
        <Box>
          <Box
            display="grid"
            gridTemplateColumns={{ xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }}
            gap={2}
          >
            {cardArray.map((index) => (
              <InlineCardSkeleton key={index} />
            ))}
          </Box>
        </Box>

        {showSidebar && (
          <Box display={{ xs: 'none', md: 'block' }}>
            <Skeleton variant="rounded" height={400} />
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default PageSkeleton;
